import React, { useState } from 'react';
import { AnchorId } from '../../../core/Enums';
import ManagerLayout from '../../../mimic/manager/ManagerLayout';
import { useTour } from '../../../core/TourProvider';
import {
  PaymentsStepId,
  PaymentsSubsceneId,
} from '../../../core/PaymentsEnums';
import { useTourAnchor } from '../../../hooks/useTourAnchor';
import BasicHeaderFields from '../../../components/BasicHeaderFields';
import BasicHeaderTabs from '../../../components/BasicHeaderTabs';
import styles from '../../../stylesheets/managerOutstandingScene.module.scss';

type ManagerTabId = 'unit' | 'transactions' | 'messages';

const ManagerClearedScene = () => {
  const { model, goTo, setSubscene } = useTour();
  const [activeTab, setActiveTab] = useState<ManagerTabId>('unit');
  const transactionsTabRef = useTourAnchor(
    AnchorId.MANAGER_CLEARED_TRANSACTIONS_TAB
  );
  const placeholderRef = useTourAnchor(AnchorId.MANAGER_CLEARED_PLACEHOLDER);
  const unitLabel = model.tenant?.unitName ?? 'Unit';

  const handleTabChange = (tabId: ManagerTabId) => {
    if (tabId === 'transactions') {
      return;
    }
    setActiveTab(tabId);
  };

  const handleTransactionsClick = () => {
    goTo(PaymentsStepId.MANAGER_TRANSACTIONS);
  };

  const handlePlaceholderClick = () => {
    setSubscene(PaymentsSubsceneId.TRANSACTIONS);
  };

  return (
    <ManagerLayout>
      <BasicHeaderFields balanceAmount={0} />
      <BasicHeaderTabs
        activeId={activeTab}
        unitLabel={unitLabel}
        onChange={handleTabChange}
        transactionsTabRef={transactionsTabRef}
        transactionsTabOnClick={handleTransactionsClick}
      />
      <div className={styles.contentSection} ref={placeholderRef}>
        {activeTab === 'unit' ? (
          <div
            className={styles.transactionsPlaceholder}
            onClick={handlePlaceholderClick}
          >
            <h2 className={styles.transactionsTitle}>No outstanding rent</h2>
            <p className={styles.transactionsBody}>
              {"This tenant doesn't have any outstanding rent."}
            </p>
          </div>
        ) : (
          <div className={styles.transactionsPlaceholder}>
            <h2 className={styles.transactionsTitle}>Messages</h2>
            <p className={styles.transactionsBody}>
              This is where you would see and send messages to your tenants.
            </p>
          </div>
        )}
      </div>
    </ManagerLayout>
  );
};

export default ManagerClearedScene;
